import QuickOverview from "./QuickOverview";

export default QuickOverview;
